module.exports = __webpack_public_path__ + "static/media/OIL.17ba1b0a.png";